// extracted by mini-css-extract-plugin
export var cancelButton = "_q3-5";
export var content = "_q3-3";
export var createButton = "_q3-6";
export var drawerContainer = "_q3-0";
export var footer = "_q3-2";
export var header = "_q3-1";
export var orderFormColumn = "_q3-4";